import styles from './designer.module.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload, faMagnifyingGlass, faPalette, faPlusCircle, faTrash, faUpload } from '@fortawesome/free-solid-svg-icons';
import { Button } from 'react-bootstrap';

interface IDesignerToolbar {
  onDeleteAllSections: () => void;
  onAddSection: (currentsection: number, above: boolean) => void;
  onOpenPageSettings: () => void;
  onPublishVersion: () => void;
  onUnPublishVersion: () => void;
  SectionCount: number;
  VersionPreviewUrl: string;
  VersionPublished: boolean;
  layoutPreviewOpen: boolean;
  onToggleLayoutPreview: () => void;
}

const DesignerToolbar = (props: IDesignerToolbar) => {
  const addSection = (): void => props.onAddSection(props.SectionCount, false);

  const onPreview = (): void => {
    if (props.VersionPreviewUrl?.length > 1) {
      window.open(props.VersionPreviewUrl, "_blank");
    }
  };

  return (
    <div className={styles.toolbar}>
      <div className={styles.toolbarInner}>

        {/* Layout */}
        <Button variant="light" onClick={addSection} className={styles.toolbarBtn} title="Add a new section">
          <FontAwesomeIcon icon={faPlusCircle} />
          Add Section
        </Button>

        <div className={styles.toolbarDivider} />

        {/* Page state */}
        <Button variant="light" onClick={props.onOpenPageSettings} className={styles.toolbarBtn} title="Open page settings">
          <FontAwesomeIcon icon={faPalette} />
          Page Settings
        </Button>

        <Button variant="light" onClick={onPreview} className={styles.toolbarBtn} title="Open preview in new tab">
          <FontAwesomeIcon icon={faMagnifyingGlass} />
          Preview
        </Button>

        <Button
          variant={props.layoutPreviewOpen ? "primary" : "light"}
          onClick={props.onToggleLayoutPreview}
          className={styles.toolbarBtn}
          title="Show the renderer page at desktop or phone width">
          {props.layoutPreviewOpen ? "Hide layout" : "Layout"}
        </Button>

        {props.VersionPublished ? (
          <Button variant="outline-secondary" onClick={props.onUnPublishVersion} className={styles.toolbarBtn} title="Unpublish this version">
            <FontAwesomeIcon icon={faDownload} />
            Unpublish
          </Button>
        ) : (
          <Button variant="success" onClick={props.onPublishVersion} className={styles.toolbarBtn} title="Publish this version">
            <FontAwesomeIcon icon={faUpload} />
            Publish
          </Button>
        )}

        <div className={styles.toolbarDivider} />

        {/* Destructive */}
        <Button variant="outline-danger" onClick={props.onDeleteAllSections} className={styles.toolbarBtn} title="Delete all sections and content">
          <FontAwesomeIcon icon={faTrash} />
          Delete All
        </Button>

      </div>
    </div>
  );
};

export default DesignerToolbar;
